import { useState } from 'react'
import { STEP } from '../constants/steps'

// Back/forward navigation on top of the raw `step` number, with two kinds of
// "come back to where I was" memory:
//  - editReturnStep: set when the user opens a section from the review screen
//    ("Bearbeiten"); leaving that section returns to the review screen.
//  - progressReturnStep: set when the user jumps backwards via the progress
//    bar; the next "Weiter" returns to the step they jumped from.
// During normal front-to-back filling both are null and goToStep/goBack are
// plain setStep calls.
export const useWizardNavigation = (step, setStep) => {
	const [editReturnStep, setEditReturnStep] = useState(null)
	const [progressReturnStep, setProgressReturnStep] = useState(null)

	const goToStep = target => {
		if (editReturnStep !== null) {
			const returnTo = editReturnStep
			setEditReturnStep(null)
			setProgressReturnStep(null)
			setStep(returnTo)
		} else if (progressReturnStep !== null) {
			const returnTo = progressReturnStep
			setProgressReturnStep(null)
			setStep(returnTo)
		} else {
			setStep(target)
		}
	}

	const goBack = target => {
		if (editReturnStep !== null) {
			const returnTo = editReturnStep
			setEditReturnStep(null)
			setProgressReturnStep(null)
			setStep(returnTo)
		} else {
			setProgressReturnStep(null)
			setStep(target)
		}
	}

	const startEditFromReview = targetStep => {
		setEditReturnStep(STEP.REVIEW)
		setStep(targetStep)
	}

	const jumpFromProgressBar = targetStep => {
		setProgressReturnStep(targetStep < step ? step : null)
		setStep(targetStep)
	}

	const clearReturnMemory = () => {
		setEditReturnStep(null)
		setProgressReturnStep(null)
	}

	return {
		goToStep,
		goBack,
		startEditFromReview,
		jumpFromProgressBar,
		clearReturnMemory,
		isReviewEdit: editReturnStep !== null,
	}
}
